import styled, { css } from "styled-components/macro";
import { COLORES } from "../../constants";


export const RecordsByPage = styled.select`
  width: 3.5rem;
  height: 1.75rem;
  text-align: center;
  outline: none;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;

  button {
    display: flex;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    border: none;
    border-radius: 0.2rem;
    cursor: pointer;
    color: ${COLORES.BUTTON_TEXT_DEFAULT};
    min-height: 1.75rem;
    align-items: center;

    :disabled {
      cursor: default;
    }
  }

  #backPage,
  #nextPage
 {
    background-color: ${COLORES.BUTTON_BACKGROUND_DEFAULT};
    :disabled {
      background-color: ${COLORES.BACKGROUND_DISABLED};
    }
  }
`;